// extracted by mini-css-extract-plugin
export var readonly = "_bc-1";
export var star = "_bc-0";